module.exports = __webpack_public_path__ + "media/关于培训班背景视频.25e87849.mp4";